<kpd-prevent-browser-close [prevent]="form.dirty"></kpd-prevent-browser-close>
<kpd-confirm-dialog key="confirm"></kpd-confirm-dialog>
<app-permission-set-wizard-copy></app-permission-set-wizard-copy>

<div class="detail__grid">
  <div class="detail__alert">
    <kpd-alert type="error" *ngIf="errorMessage" icon="error-standard">
      {{ errorMessage }}
    </kpd-alert>

    <kpd-alert type="warning" *ngIf="concurrencyErrorMessage" icon="warning-standard">
      {{ concurrencyErrorMessage }}
      <a style="color: #14a6fe;" (click)="reloadEntity(item)">{{ reloadMessage }}</a>
    </kpd-alert>

    <kpd-alert type="warning" *ngIf="isKpdSet" icon="warning-standard">
      {{ 'Attention! This is a' | translate }}
      <img src="assets/logos/kpd-logo_36x16.svg" alt="KPD" class="kpd-logo--blue-sm" />
      {{ 'permisson set, editing is not allowed.' | translate }}
    </kpd-alert>

    <kpd-alert type="warning" *ngIf="!canManage" icon="warning-standard">
      {{ 'You are not authorized to change this permission set' | translate }}
    </kpd-alert>
  </div>

  <div class="detail__toolbar detail__toolbar--over">
    <kpd-action-bar>
      <kpd-action-create
        (action)="onAdd()"
        [disable]="item.isNew()"
        [title]="'Add permission set' | translate"
        *kpdPermission="Permissions.PermissionsetCreate"
      >
      </kpd-action-create>
      <ng-container *ngIf="!item.isNew() && !keyOfPermissionSetToCopy">
        <kpd-action
          *kpdPermission="Permissions.PermissionsetCopy"
          icon="copy"
          (action)="onCopy()"
          [title]="'Copy permission set' | translate"
        ></kpd-action>
      </ng-container>
      <kpd-action-edit-toggle
        [readMode]="!readOnlyMode"
        (action)="toggleReadOnly()"
        [disable]="form.dirty || item.isNew()"
        *kpdPermission="Permissions.PermissionsetUpdate"
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <ng-container *ngIf="!readOnlyMode">
        <kpd-action-save (action)="onSave(form)" [disable]="!form.dirty"></kpd-action-save>
        <kpd-action-undo (action)="onRevert()" [disable]="!form.dirty"></kpd-action-undo>
      </ng-container>
      <kpd-action-delete
        *kpdPermission="Permissions.PermissionsetDelete"
        (action)="onDelete(item)"
        [disable]="!canManage || item.isNew()"
      ></kpd-action-delete>
    </kpd-action-bar>
  </div>
  <div class="detail__main">
    <form
      [formGroup]="form"
      kpdPreventEnterSubmit
      novalidate
      (kpdFocusChange)="onFocusChanged($event)"
      [ngClass]="{ update: !item.isNew(), create: item.isNew(), 'form--edit-mode': !item.isNew() }"
    >
      <kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
        <div class="flex-column form__column">
          <div class="form__control flex-row">
            <label>{{ 'Application' | translate }}:</label>
            <div class="form__input">
              <kpd-data-lookup
                formControlName="application"
                [items]="applications"
                [title]="'Application' | translate"
                [readOnly]="readOnlyMode || !item.isNew() || isKpdSet || !canManage"
                simple="true"
                [displayField]="'name'"
                [secondaryDisplayField]="'description'"
                [searchField]="'name'"
                [valueField]="'name'"
                [name]="'application'"
                [columns]="nameAndDescriptionColumns"
              >
              </kpd-data-lookup>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'Name' | translate }}:</label>
            <div class="form__input">
              <kpd-text-input
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="name"
                [name]="'name'"
              ></kpd-text-input>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'Type' | translate }}:</label>
            <div class="form__input">
              <p-selectButton
                [options]="typeOptions"
                formControlName="type"
                *ngIf="!readOnlyMode && !isKpdSet && canManage"
              ></p-selectButton>
              <label class="value tags" *ngIf="readOnlyMode || isKpdSet || !canManage">
                <span
                  class="state-tag"
                  [ngClass]="{ 'state-tag--disabled': form.value.type !== 'assign' && form.value.type !== 'both' }"
                  translate
                  >Assign</span
                >
                <span
                  class="state-tag"
                  [ngClass]="{ 'state-tag--disabled': form.value.type !== 'use' && form.value.type !== 'both' }"
                  translate
                  >Use</span
                >
              </label>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'Description' | translate }}:</label>
            <div class="form__input">
              <kpd-text-area
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="description"
                [name]="'description'"
                rows="5"
                [kpdSyncField]="languageFields"
              ></kpd-text-area>
            </div>
          </div>
        </div>
      </kpd-collapse-panel>
      <kpd-collapse-panel title="{{ 'Descriptions' | translate }}" [collapsed]="true" formGroupName="descriptions">
        <div class="flex-column form__column">
          <div class="form__control flex-row">
            <label class=" ">{{ 'Dutch' | translate }}:</label>
            <div class="form__input">
              <kpd-text-area
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="dutch"
                [name]="'dutch'"
                rows="5"
                [kpdSyncField]="hasTranslationSync('dutch')"
              ></kpd-text-area>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'English' | translate }}:</label>
            <div class="form__input">
              <kpd-text-area
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="english"
                [name]="'english'"
                rows="5"
                [kpdSyncField]="hasTranslationSync('english')"
              ></kpd-text-area>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'French' | translate }}:</label>
            <div class="form__input">
              <kpd-text-area
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="french"
                [name]="'french'"
                rows="5"
                [kpdSyncField]="hasTranslationSync('french')"
              ></kpd-text-area>
            </div>
          </div>
          <div class="form__control flex-row">
            <label class=" ">{{ 'German' | translate }}:</label>
            <div class="form__input">
              <kpd-text-area
                [readOnly]="readOnlyMode || isKpdSet || !canManage"
                formControlName="german"
                [name]="'german'"
                rows="5"
                [kpdSyncField]="hasTranslationSync('german')"
              ></kpd-text-area>
            </div>
          </div>
        </div>
      </kpd-collapse-panel>
    </form>
  </div>
</div>
